import React, { useState, useEffect } from 'react';

export const Counter = ({ end, duration = 2000 }) => {
	const [count, setCount] = useState(0);

	useEffect(() => {
		let startTime;
		let animationFrame;

		const animate = (currentTime) => {
			if (!startTime) startTime = currentTime;
			const progress = Math.min((currentTime - startTime) / duration, 1);

			setCount(Math.floor(progress * end));

			if (progress < 1) {
				animationFrame = requestAnimationFrame(animate);
			}
		};

		animationFrame = requestAnimationFrame(animate);

		return () => {
			if (animationFrame) {
				cancelAnimationFrame(animationFrame);
			}
		};
	}, [end, duration]);

	return <span>{count}</span>;
};
